module.exports = __webpack_public_path__ + "img/poll-active-icon.d8c7028b.svg";